import Spinner from 'react-bootstrap/Spinner'

type MessageLoaderProps = {
  message: string
  containerClass?: string
}

const MessageLoader: React.FC<MessageLoaderProps> = ({
  message,
  containerClass,
}) => (
  <div className={`${containerClass} flex-center`}>
    <span className="mr-3 fs-18">{message}</span>
    <Spinner animation="border" />
  </div>
)

export default MessageLoader
